


























































































































































































































  import { Component, Vue } from "vue-property-decorator";
  import { mapGetters, mapActions } from "vuex";
  import BillboardListHome from "@/components/billboard/billboard-list-home/BillboardListHome.vue";
  import Birthdays from "@/components/birthdays/Birthdays.vue"
  import recentHired from "@/components/recentHired/RecentHired.vue"
  import AbsentUsers from "@/components/absentUsers/AbsentUsers.vue"
  import SelectIconFilter from "@/components/generics/SelectIconFilter.vue"
  import BarChart from "@/components/home/BarChart.vue";
  import WidgetTareas from "@/components/home/WidgetTareas.vue";
  import EmployeeActiveStatus from "@/components/home/EmployeeActiveStatus.vue";
  import EmployeeOnboardingStatus from "@/components/home/EmployeeOnboardingStatus.vue";
  import PopupMantenimiento from "@/components/generics/PopupMantenimiento.vue";
  import PopupFileUploadLicenses from "@/components/generics/PopupFileUploadLicenses.vue";
  import User from "../apiClient/User";
  import { BasicClient } from "@/utils/httpClient";
  
  interface Data {
	isVisible: boolean
  }
  
  @Component({
	  name: "Home",
	  components: {
		  'BillboardListHome': Vue.extend(BillboardListHome),
		  'Birthdays': Vue.extend(Birthdays),
		  'recentHired': Vue.extend(recentHired),
		  'SelectIconFilter': Vue.extend(SelectIconFilter),
		  'BarChart': Vue.extend(BarChart),
		  'WidgetTareas': Vue.extend(WidgetTareas),
		  'EmployeeActiveStatus': Vue.extend(EmployeeActiveStatus),
		  'EmployeeOnboardingStatus': Vue.extend(EmployeeOnboardingStatus),
		  'PopupMantenimiento': Vue.extend(PopupMantenimiento),
		  'AbsentUsers': Vue.extend(AbsentUsers),
		  PopupFileUploadLicenses,
	  },
	  methods: {
		  ...mapActions(["setInitialCountry"]),
  
		  permissionUserOnButton(id) {
			  if (!this.$store.state.permissions) {
				  return false;
			  }
			  if (this.$store.state.permissions.length > 0) {
				  if (this.$store.state.permissions.includes(id)) {
					  return true;
				  }
			  }
			  return false;
		  }
  
	  },
	  computed: {
		  ...mapGetters(["getUser"])
	  }
  })
  
  export default class Home extends Vue {
	  getUser:any;
	  setInitialCountry: () => void;
	  permissionUserOnButton: (a) => boolean;
	  locationOrigin;
	  changedAvatar;
	  user;
	  userStatus;
	  tabs;
	  selectedTab;
	  client;
	  sichernCommunity;
	  async created() {
			
	  this.client = new BasicClient();
	  this.user = new User();
  
		  this.setInitialCountry();
			const veeValidateLocale = this.getUser.pais === 'BR' ? 'pt-br' : 'es'
    	this.$validator.localize(veeValidateLocale);
		  document.querySelectorAll('.modal-backdrop').forEach(el => el.classList.remove('fade'))
		  document.querySelectorAll('.modal-backdrop').forEach(el => el.classList.add('hide'))
  
		  if(this.permissionUserOnButton(83)){
			  this.tabs.push('birthdays');
		  }
		  if(this.permissionUserOnButton(84)){
			  this.tabs.push('recentHired');
		  }
		  //mostrar ausentes y gestion de lic. rrhh
		  const mostrarAusentes = 85;
		  const gestionLicRrhh = 81;
		  if(this.permissionUserOnButton(mostrarAusentes) && this.permissionUserOnButton(gestionLicRrhh)){
			  this.tabs.push('absentUsers');
		  }
		  this.selectedTab = this.tabs[0];
  
		  this.dataUserStatus();
		  this.getNotificationsPush()
	  this.getSichernCommunity();
	  }
	  data() {
		  return {
			  locationOrigin: location.origin,
			  changedAvatar: 0,
			  tabs: [],
			  selectedTab: '',
			  selectedSectorBirthdays: 'Ver todos',
			  selectedSectorRecentHired: 'Ver todos',
			  userStatus: null,
			  user: null,
			  notificationPush: '',
		client: null,
		sichernCommunity: [],
		  };
	  }
	  avatarChanged(value) {
		this.changedAvatar = value
	  }
	  dataUserStatus() {
			  this.user.getStatus()
		  .then(response => {
			if (response.status === 200) {
						  const res = response.data.data;
			  if(res[0]){
				this.userStatus = res[0];
			  }
			}
		  })
		  .catch(error => {
			  this.userStatus = null;
		  });
	  }
	async getSichernCommunity() {
	  const data = await this.client.exec('/externalapis/sichern-community/news', "GET");
	  this.sichernCommunity = data.data.data.data.items.splice(0, 3);
	}
	  getNotificationsPush() {
		  if(this.$store.state.notifyPushVisualizations === 0){
			  let esRRRHHSector = false;
		   this.$store.dispatch('getProfile')
		.then((res) =>{
			let perfArr = res.perfiles;
			for (var i in perfArr) {
			  if (perfArr[i].nombre.includes("RRHH_X_SECTOR"))
				esRRRHHSector = true;
			}
			if (!esRRRHHSector){
				this.user.getNotificationsPush()
							  .then(response => {
								  if (response.status === 200) {
									  const res = response.data.results.data[0];
									  if(res[0]){
										  this.$store.dispatch('setNotifyPushVisualizations', 1);
										  this.$store.dispatch('setNotifyPush', res[0]);
									  }
								  }
							  })
							  .catch(error => {
								  console.log(error);
							  });
			}
		})
		.catch((error) =>{
		  console.log(error);
		});
		  }
	}
  }
  